/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef, EventEmitter,
  Input,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NgxDurationInputService} from '../../../../../admin-shared/services/ngx-duration-input.service';

@Component({
    selector: 'app-issue-estimate',
    templateUrl: './issue-estimate.component.html',
    styleUrls: ['./issue-estimate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueEstimateComponent implements OnInit {
  @Input() value: number;
  @Input() readOnly: boolean;
  @Output() update = new EventEmitter<number>();

  focusInput = false;
  inputControl: FormControl;

  @ViewChild('inputElement') inputElement: ElementRef;

  constructor(private readonly durationService: NgxDurationInputService) {
  }

  ngOnInit(): void {
    this.inputControl = new FormControl(this.value);
  }

  formatDuration(n: number) {
    return this.durationService.getDurationString(n);
  }

  showEstimate() {
    if (!this.readOnly) {
      this.focusInput = true;
      setTimeout(() => this.inputElement.nativeElement.focus());
    }
  }

  changeDiffTime() {
    if (undefined !== this.inputControl.value) {
      this.focusInput = false;
      if (this.inputControl.value !== this.value) {
        this.update.emit(this.inputControl.value);
      }
    }
  }
}
